import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { max300LengthRule } from 'consts/rules/textRules';

export const DiseasesInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Choroby"
        name={formFields.diseases}
        rules={[max300LengthRule]}
        accessibilityLabel="Pole choroby"
        {...props}
    >
        <AppInput
            autoComplete="off"
            accessibilityLabel="Pole choroby"
            placeholder="Podaj choroby"
        />
    </AppFormItem>
);
